import { Fragment } from 'react';
import { Shipment } from 'models/OrderHistoryMenu';

function TrackingNumbers({ shipments } : { shipments: Shipment[] }): JSX.Element {
  return (
    <div className="c-order__tracking-no--order-history">
      <strong>
        {shipments && shipments.length > 1
          ? 'Tracking numbers: '
          : 'Tracking number: '}
      </strong>

      {shipments && shipments.map((shipment, index) => (
        <Fragment key={shipment.tracking_number}>
          <a
            href={shipment.delivery_tracking_url}
            target="_blank"
            rel="noreferrer"
            className={
              shipments.length > 1
                ? 'u-text--truncate'
                : undefined
            }
          >
            {shipment.tracking_number}
          </a>
          {index !== shipments.length - 1 && ', '}
        </Fragment>
      ))}

      {(!shipments || !shipments.length) && (
        <span className="u-text u-text--muted">
          Pending
        </span>
      )}
    </div>
  );
}

export default TrackingNumbers;
